export default __webpack_public_path__ + "static/media/Application Form for New EPE Applicants.70035506.docx";